import React from 'react';
import css from './SupplierPortal.module.scss';
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import wct from "../../../assets/images/extra/logowct.png";
import ord from "../../../assets/images/extra/logoord.png";
import angular from "../../../assets/images/extra/angular.png";
import java from "../../../assets/images/extra/java-coffee-cup-logo.png";
import springBoot from "../../../assets/images/extra/springBoot.png";
import mongoDB from "../../../assets/images/extra/mongoDB.png";
import git from "../../../assets/images/extra/git.png";
import talend from "../../../assets/images/extra/talend.png";
import redis from "../../../assets/images/extra/redis.png";
import maven from "../../../assets/images/extra/maven.png";
import supplierPortal from "../../../assets/images/projectsImage/supplierPortal.jpg";

const SupplierPortal: React.FC = () => (
    <div className={css.project} id="supplierPortal">
        <img src={supplierPortal} alt=""/>
        <div className={css.projectInformationContainer}>
            <div className={css.projectName} style={{position: 'relative'}}>
                <h3>Supplier Portal</h3>
                <Tooltip title="Host Company">
                    <img src={wct} width={52} height={25}
                         onClick={() => window.open('http://whitecapetech.com/', "_blank")}
                         style={{marginLeft: '1em', position: 'absolute', right: 35, cursor: 'pointer'}}
                         alt=""/>
                </Tooltip>
                <Tooltip title="Client">
                    <img src={ord} width={25} height={25}
                         onClick={() => window.open('https://ordiges.com/en/', "_blank")}
                         style={{marginLeft: '1em', position: 'absolute', right: 0, cursor: 'pointer'}}
                         alt=""/>
                </Tooltip>
            </div>

            <div className={css.info}>
                <Chip label="5 Months" variant="outlined" size='small'/>
            </div>
            <div className={css.infoSmallScreen}>
                <Chip label="5 Months" variant="outlined" size='small'/>
            </div>

            <h5 className={css.textSectionInfo}>Description:</h5>
            <p className={css.description}>
                I realized this project as my last year internship and I was charged with analysing client
                requests, designing and developing the application.</p>
            <p className={css.description}>
                On the other hand, it's an application that opens a portal to <a
                className={css.link}
                target="_blank"
                rel="noopener noreferrer"
                href="https://ordiges.com/solutions-performance-entreprise/askgo-logiciels-gestion/solution-achat-public/">
                Ask&Go</a> solution, allowing suppliers to manage their invoices, orders, contacts and users.
            </p>
            <div className={css.learnMoreLink}>
                <p>Source Code: <a className={css.link}
                                   href='https://github.com/search?q=user%3Aadhess+supplier'
                                   rel="noopener noreferrer"
                                   target="_blank">https://github.com/search?q=user%3Aadhess+supplier</a>
                </p>
            </div>



            <h5 className={css.textSectionInfo}>Tasks:</h5>
            <ul className={css.tasks}>
                <li>Designed and developed micro-services architecture with a simple system for role
                    management.
                </li>
                <li>Injected MongoDb with data extracted from MsSql using Talend ESB.</li>
            </ul>


            <h5 className={css.textSectionInfo}>Supervisors:
                <a className={css.link} href='https://www.linkedin.com/in/taha-ben-salah/'
                   rel="noopener noreferrer" target="_blank">Taha Ben Salah</a>
                |
                <a className={css.link} href='https://www.linkedin.com/in/ines-heni-01858620/'
                   rel="noopener noreferrer" target="_blank">Ines Heni</a>
                |
                <a className={css.link} href='https://www.linkedin.com/in/wael-boukadida-36025645/'
                   rel="noopener noreferrer" target="_blank">Wael Boukadida</a>
            </h5>


            <h5 className={css.textSectionInfo}>Keywords:</h5>
            <div className={css.keywords} >
                <Tooltip title="Json Web Token">
                    <Chip label="JWT" color="primary" variant="outlined" size='small'/>
                </Tooltip>
                <Tooltip title="Netflix Zuul">
                    <Chip label="Zuul" color="primary" variant="outlined" size='small'/>
                </Tooltip>
                <Tooltip title="Eureka">
                    <Chip label="Eureka" color="primary" variant="outlined" size='small'/>
                </Tooltip>
                <Tooltip title="Architecture Micro-Services">
                    <Chip label="Micro-Services" color="primary" variant="outlined" size='small'/>
                </Tooltip>
            </div>
            <div className={css.keywords}>
                <Tooltip title="Angular">
                    <img src={angular} alt=""/>
                </Tooltip>
                <Tooltip title="Java">
                    <img src={java} alt=''/>
                </Tooltip>
                <Tooltip title="Spring Boot">
                    <img src={springBoot} alt=''/>
                </Tooltip>
                <Tooltip title="Maven">
                    <img src={maven} alt=""/>
                </Tooltip>
                <Tooltip title="MongoDB">
                    <img src={mongoDB} alt=""/>
                </Tooltip>
                <Tooltip title="Redis">
                    <img src={redis} alt=""/>
                </Tooltip>
                <Tooltip title="Talend ESB">
                    <img src={talend} alt=""/>
                </Tooltip>
                <Tooltip title="Git">
                    <img src={git} alt=""/>
                </Tooltip>
            </div>

        </div>
    </div>
);

export default SupplierPortal;
